import { GET, POST } from 'owa-ows-rest-api';
import { TeamsChannel } from './schema';

// For documentation of this API, see
// https://outlook-sdf.office.com/ows/swagger/index.html#/TeamsChannels

const teamsChannelsUri = 'ows/api/TeamsChannels';

export function getTeamsChannelsSDS() {
    const getTeamsChannelsUri = teamsChannelsUri + '/findall';
    return GET<TeamsChannel[]>(getTeamsChannelsUri);
}

export function addTeamsChannelsSDS(newTeamsChannels: TeamsChannel) {
    const addTeamsChannelsUri = teamsChannelsUri + '/add';
    return POST<TeamsChannel>(addTeamsChannelsUri, newTeamsChannels);
}
